
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import addressPicker from '@/views/components/address-picker2'
import config from '@/config'
import banner from '@/assets/manyidadiaocha/banner.png'
import { getSurveyQuestion, getSurveyList, postSurvey, check, getTitle } from '@/api/youzheng'
import { getAddressDefault, getUserAccount, operateCreditlist } from '@/api/user.js'
import { getRequest } from '@/libs/utils'
import { getUserinfo } from '@/api/user'
import Storage from '@/storage'
import { getCityYzwj, getJdYzwj, getCounty, getDepart } from '@/api/sys.js'
export default {
name: 'quesAsk',
components: {
XTextarea,
XDialog,
Msg,
Toast,
XButton,
XInput,
Group,
PopupPicker,
addressPicker
},
data () {
return {
advise: '',
baseUrl: config.baseUrl,
banner: banner,
title: '',
list: [],
listAll: [],
listDom: null,
moreshow: true,
suTitle: '',
Answer: {},
Textarea: {},
Textshow: {},
Textholder: {},
timuID: [],
timuIndex: 0,
timuAnswer: [],
person: {
acctname: '', // 姓名
workaddress: '', // 单位
mobile: '', // 联系电话
birthprovinceid: 1,
birthcityid: '',
birthcountyid: '',
address: ''
},
birthcity_id: [],
isShow: false,
citylist: [],
jdlist: [],
jdlist_id: [],
addressValue: [31, '', ''],
paperid: this.$route.params.paperid,
activityid: this.$route.params.type,
isclick: false,
multi: [],
multishow: [],
TextshowCheck: {},
TextareaCheck: {},
isstart: true,
anslist: [],
isans: true,
listss: [],
addTreeNode: 1,
show_county: false,
listshow: false,
contentlist: [],
tipsList: [
{
title: 1,
tips: '企业经营步入良性循环，各项指标比去年有所提高优化。'
},
{
title: 2,
tips: '把“两个维护”体现在坚决贯彻党中央决策部署的行动上,体现在履职尽责、做好本职工 作的实效上,体现在党员、干部的日常言行上。'
},
{
title: 3,
tips: '扎实开展党史学习教育和纪念建党百年活动；领导干部带头讲党课，理论水平高。'
},
{
title: 4,
tips: '急难险重任务目前，党员领导干部身先士卒，做好表率；广泛开展党员“三亮三比三评”活动，比学赶帮超。'
},
{
title: 5,
tips: '为员工办实事、办好事、解难事，努力提高职工福利待遇，改善生产条件，关心员工身心健康。'
},
{
title: 6,
tips: '深入基层，联系群众，真抓实干，脚踏实地；持续纠治形式主义、官僚主义，不说空话假话套话。'
},
{
title: 7,
tips: '部门协作顺畅，不推诿不扯皮，齐心协力，内耗少。'
},
{
title: 8,
tips: '坚持德才兼备标准选人用人，抓好优秀年轻干部的培养；发挥各个年龄段人员的作用，把人用在合适的岗位上，人尽其才，物尽其用。'
},
{
title: 9,
tips: '制度设计科学合理，实施过程公正公开，员工服气。'
},
{
title: 10,
tips: '加强执纪监督。认真查处靠邮吃邮、设租寻租等腐败问题和偷逃邮件重量、挪用资金、邮件丢失等问题，常态化开展纪律教育，引导党员干部严守党的六大纪律。'
}
]
}
},
created () {
this.gettitleNow()
this.view()

this.getUserMessage()
this.getuser()

this.getCityid()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}

},
mounted () {
this.listDom = this.$el.querySelector('.paper .cont>ul')
},
watch: {
birthcity_id () {
this.person.birthcityid = this.birthcity_id[0]
this.jdlist_id = []
this.addTreeNode = this.person.birthcityid
this.getJdid()
},
multi: {
handler: function (newVal, oldVal) {
},
deep: true
}
},
methods: {
addCredit () {
operateCreditlist({
accountid: this.accountid,
rulecode: 'contribute4',
credit: 5,
owner_type: '2007',
terminaltype: 2
}).then(res => { })
},
checkblock (index, value) {
this.listAll[index].model = value.replace(/\s+/g, '')
},
gettitleNow () {
getTitle({
activityid: this.activityid
}).then(res => {
this.title = res.returnValue.TITLE
})
},

view () {
getSurveyList({
activityid: this.activityid
}).then(res => {
if (res.status === 'suc') {
res.returnValue.PAPERLIST.forEach(re => {
if (re.PAPERID == this.paperid) {
this.isclick = true
this.startTime = re.BEGINDATE.replace(/-/g, '/')
this.endTime = re.ENDDATE.replace(/-/g, '/')
this.getcheck()
this.getList()
}
})



}
}).catch(res => {
this.isstart = false

})
},
getcheck () {
check({
paperid: this.paperid,
accountid: this.accountid
}).then(res => {
let _this = this
if (!res.returnValue.flag) {
this.isclick = false
this.$vux.alert.show({
content: '您已经填过问卷了！'
})
}
})
},
getCityid () {
var _this = this
getCityYzwj({
plistvalue: this.person.birthprovinceid
}).then(data => {
data.obj.forEach(element => {
if (element.key != '') {
_this.citylist.push({
name: element.value,
value: element.key + ''
})
}
})
})
},
getJdid () {
var _this = this
getCityYzwj({
plistvalue: _this.addTreeNode
}).then(data => {
_this.jdlist = []
data.obj.forEach(element => {
if (element.key != '') {
_this.show_county = true
_this.jdlist.push({
name: element.value,
value: element.key + ''
})
} else {
_this.show_county = false
}
})
})
},
getList () {
getSurveyQuestion({
paperid: this.paperid
}).then(res => {
this.listAll = res.returnValue.ROWLIST
this.suTitle = res.returnValue.TITLE
this.listAll.forEach((item, index) => {
if (item.ROWTYPE === 2) {
item.ROWLIST.forEach((res, i) => {
if (res.TYPE === 2) {
this.multi[i] = res
this.multishow.push(this.multi[i])
this.multi[i].OPTIONLIST.forEach(obj => {
this.$set(obj, 'checked', false)
this.$set(obj, 'model', '')
})
} else if (res.TYPE === 3) {
this.multi[i] = res
this.$set(res, 'model', '')
this.multishow.push(this.multi[i])
}
if (index == 1) {
res.tips = this.tipsList[i].tips
}
this.timuID[this.timuIndex++] = res.SUBJECTID
})
} else {
if (item.TYPE === 2) {
this.multi[index] = item
this.multishow.push(this.multi[index])
this.multi[index].OPTIONLIST.forEach(obj => {
this.$set(obj, 'checked', false)
this.$set(obj, 'model', '')
})
} else if (item.TYPE === 3) {
this.multi[index] = item
this.$set(item, 'model', '')
this.multishow.push(this.multi[index])
}
this.timuID[this.timuIndex++] = item.SUBJECTID
}
})
})
},
bodyScroll (event) {
event.preventDefault()
},
stopScroll () {
document.body.style.overflow = 'hidden'
document.addEventListener('touchmove', this.bodyScroll, { passive: false })
},
startScroll () {
document.body.style.overflow = ''
document.removeEventListener('touchmove', this.bodyScroll, false)
},
checkText (id, istk, textholder, optid) {
if (istk == 1) {
this.Textshow[id] = true
this.Textholder[id] = textholder
} else {
this.Textshow[id] = false
}
},
checkTextBox (id, opt, index, i) {
console.log('checktextbox', opt)
if (opt.ISTK == 1) {
if (!opt.checked) {
opt.model = ''
this.contentlist[id] = ''
} else {
this.listshow = true
}
}
},
close_dia () {
this.isShow = false
this.startScroll()
},
postAdd () {
if (this.isclick) {
let checkItem = []
let ret = {}
let ret2 = {}
let textarea = {}
let area = []
let textshow = {}
let show = []
this.multishow.forEach((item, index) => {
if (item.TYPE == 2) {
if (item.OPTIONLIST.length > 0) {
checkItem = []
area = []
show = []
item.OPTIONLIST.forEach((obj, i) => {
if (obj.checked && obj.ISTK == 2) { // 复选框&&点击后不弹出填写信息
checkItem[i] = obj.OPTIONID
show[i] = true
}
if (obj.checked && obj.ISTK == 1 && obj.model == '') { // 复选框&&点击后填写信息&&信息框为空
this.isans = false
}
if (obj.model != '' && obj.ISTK == 1) { // 信息框不为空&&点击后填写信息
checkItem[i] = obj.OPTIONID
show[i] = true
this.contentlist[item.SUBJECTID] = obj.model
area.push(obj.model)
}
if (obj.model == '' && obj.ISTK == 1) { // 信息框为空&&点击后填写信息
this.contentlist[item.SUBJECTID] = ''
}
})
if (checkItem.length > 0) {
ret[item.SUBJECTID] = checkItem
}
checkItem.forEach(item => {
if (checkItem.length > 0) {
this.anslist.push(item)
}
})
if (checkItem.length === 0) {
this.isans = false
}
textarea[item.SUBJECTID] = area.join(',')
textshow[item.SUBJECTID] = show.join(',')
Object.assign(this.Answer, ret)
this.TextareaCheck = textarea
this.TextshowCheck = textshow
}
} else if (item.TYPE == 3) {
if (item.model.length == 0) {
this.isans = false
} else {
ret2[item.SUBJECTID] = item.model
Object.assign(this.Answer, ret2)
}
}
})
console.log(Object.keys(this.Answer).length)
console.log(this.timuIndex)
console.log(this.Answer)
if (Object.keys(this.Answer).length < this.timuIndex || this.isans == false) {
this.$vux.toast.text('问卷未填完！', 'middle')
this.isans = true
return
}
for (let key in this.TextshowCheck) {
if (this.TextshowCheck[key]) {
for (let i in this.TextshowCheck[key]) {
if (i == '' || i == null || this.javaTrim(i) === '') {
this.$vux.toast.text('请填写理由！', 'middle')
return
}
}
}
}
for (let key in this.Textshow) {
if (this.Textshow[key]) {
if (this.Textarea[key] == '' || this.Textarea[key] == null || this.javaTrim(this.Textarea[key]) === '') {
this.$vux.toast.text('请填写理由！', 'middle')
return
}
}
}
this.isShow = true

this.timuAnswer = []
this.timuID.forEach((item, index) => {
if (this.Textshow[item]) {
this.timuAnswer[index] = { subjectid: item, optionList: [{ optionid: this.Answer[item], tkcontent: this.Textarea[item] }] }
} else if (this.Answer[item].length > 0) {
if (this.contentlist[item] != '') {
let list = []
if (typeof (this.Answer[item]) !== 'string') {
this.Answer[item].forEach(res => {
if (res == 10130 || res == 10124) { // 问题未解决
list.push({ 'optionid': res, 'tkcontent': this.contentlist[item] })
} else {
list.push({ 'optionid': res })
}
})
this.timuAnswer[index] = { subjectid: item, optionList: list }
} else if (typeof (this.Answer[item]) === 'string') {
this.timuAnswer[index] = { subjectid: item, tkcontent: this.Answer[item] }
}
} else {
let list = []
this.Answer[item].forEach(res => {
list.push({ 'optionid': res })
})
this.timuAnswer[index] = { subjectid: item, optionList: list }
}
} else {
this.timuAnswer[index] = { subjectid: item, optionList: [{ optionid: this.Answer[item] }] }
}
})
console.log('timeanswer', JSON.stringify(this.timuAnswer))
}
},
countProperties (obj) {
var count = 0
for (var property in obj) {
if (Object.prototype.hasOwnProperty.call(obj, property)) {
count++
}
}
return count
},
getuser () {
Storage.set('token', '')
getUserinfo({
code: getRequest().code,
userid: this.$store.state.user.userid
}).then(res => {
if (res.status === 'suc') {
if (!res.returnValue.userid) {
this.$vux.alert.show({
title: '请求出错',
content: '您不是该企业用户成员'
})
} else {
Storage.set('token', res.returnValue.token)
this.addCredit()
}
}
})
},
endAdd () {
if (this.person.acctname === '') {
this.$vux.toast.text('请输入用户姓名！', 'middle')
this.$refs.acctname.focus()
return false
}
let myreg = /^1[3456789]\d{9}$/
if (this.person.mobile === '') {
this.$vux.toast.text('请输入联系电话！', 'middle')
this.$refs.mobile.focus()
return false
} else if (!myreg.test(this.person.mobile)) {
this.$vux.toast.text('请输入正确的手机号', 'middle')
this.$refs.mobile.focus()
return false
}





if (this.person.birthcityid.length === 0) {
this.$vux.toast.text('请选择所在地市！', 'middle')
return false
}
if (this.jdlist_id.length === 0 && this.birthcity_id[0] !== '23') {
this.$vux.toast.text('请选择所在区县！', 'middle')
return false
}
this.isShow = false
this.startScroll()
postSurvey({
accountid: this.accountid,
paperid: this.paperid,
mobile: this.person.mobile,
acctname: this.person.acctname,

provinceid: this.person.birthprovinceid,
citynewid: this.person.birthcityid,

submitList: JSON.stringify(this.timuAnswer),
countynewid: this.jdlist_id[0]
}).then(res => {
if (res.status == 'suc') {
operateCreditlist({
accountid: this.accountid,
rulecode: 'inquire2',
credit: 50,
owner_type: '2007',
terminaltype: 2
}).then(res => {
this.$vux.toast.show({ text: '问卷提交成功，恭喜你获得50积分', time: '2000', position: 'middle' })


setTimeout(() => {
this.$router.go(-1)

}, 1500)
})
}
})
},

getdefault () {
getAddressDefault({
userid: this.userid,
accountid: this.accountid
}).then(data => {
if (data.returnValue != '') {
this.person.acctname = data.returnValue.NAME
this.person.mobile = data.returnValue.MOBILE
this.$set(this.addressValue, 0, data.returnValue.PROVINCEID.toString())
this.$set(this.addressValue, 1, data.returnValue.CITYID.toString())
this.$set(this.addressValue, 2, data.returnValue.COUNTYID.toString())
this.person.address = data.returnValue.ADDRESS
} else {
this.isAddress = false
}
})
},
getUserMessage () {
getUserAccount({
accountid: this.accountid
}).then(res => {
if (res.status === 'suc') {
this.person.acctname = res.returnValue.acctname
this.person.mobile = res.returnValue.mobile
}
})
},

javaTrim (str) {
for (var i = 0; (str.charAt(i) == ' ') && i < str.length; i++);
if (i == str.length) return '' 
var newstr = str.substr(i)
for (var i = newstr.length - 1; newstr.charAt(i) == ' ' && i >= 0; i--) { newstr = newstr.substr(0, i + 1) }
return newstr
}
}
}
